import { useRef, useState } from 'react';
import { Link as RLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { logout } from 'actions/account';
import { ArrowDropDown } from '@mui/icons-material';
import { Avatar, Box, ButtonBase, Hidden, Menu, MenuItem, Typography, Link } from '@mui/material';

const styles = {
  avatar: {
    height: 32,
    width: 32,
    marginRight: 1
  },
  popover: {
    width: 250
  },
  link: {
    color: 'inherit',
    textDecoration: 'inherit',
    '&:hover': {
      textDecoration: 'inherit'
    }
  }
};

const Account = () => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.account.user);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpen, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      dispatch(logout());
    } catch (error) {
      enqueueSnackbar('Unable to logout', {
        variant: 'error'
      });
    }
  };

  return (
    <>
      <Box display="flex" alignItems="center" component={ButtonBase} onClick={handleOpen} ref={ref}>
        <Avatar alt="User" sx={styles.avatar} src={user.avatar} />

        <Hidden smDown>
          <Typography variant="h6" color="inherit">
            {`${user.firstName} ${user.lastName}`}
          </Typography>
        </Hidden>
        <ArrowDropDown />
      </Box>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        keepMounted
        anchorEl={ref.current}
        open={isOpen}
      >
        <Box>
          <MenuItem component={RLink} to="/profile" sx={styles.link}>
            Perfil
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('can_sign_in_price_configurator')}>
          <MenuItem component={Link} href={process.env.REACT_APP_RULES_CONFING_URL || 'https://admin.autored.cl/'} target="_blank" sx={styles.link}>
            Reglas de negocio
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('assign_attending_evaluators')}>
          <MenuItem component={RLink} to="/companies/select_evaluator_priorities" sx={styles.link}>
            Configuración de evaluadores
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('show_manage_sellers')}>
          <MenuItem component={RLink} to="/companies/manage_users" sx={styles.link}>
            Configuración de usuarios
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('show_manage_branches')}>
          <MenuItem component={RLink} to="/companies/manage_branches" sx={styles.link}>
            Configuración de sucursales
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('manage_rebuyers')}>
          <MenuItem component={RLink} to="/companies/rebuyer_configuration" sx={styles.link}>
            Configuración de mayoristas
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('can_create_bonus')}>
          <MenuItem component={RLink} to="/bonus-settings" sx={styles.link}>
            Bonos
          </MenuItem>
        </Box>
        <Box>
          <MenuItem component={RLink} to="/promotions" sx={styles.link}>
            Novedades
          </MenuItem>
        </Box>
        <Box hidden={!user.permissions.includes('manage_company_clients')}>
          <MenuItem component={RLink} to="/company_clients" sx={styles.link}>
            Administrar clientes
          </MenuItem>
        </Box>
        <MenuItem onClick={handleLogout}>Salir</MenuItem>
      </Menu>
    </>
  );
};

export default Account;
